const PROJECT_KITS_ENDPOINT =
  "https://thtkezikcouhbizskbrp.supabase.co/functions/v1/website-project-kits";

export class ProjectKitsAPIError extends Error {
  constructor(message, status = 0, code = "") {
    super(message);

    this.name = "ProjectKitsAPIError";
    this.status = status;
    this.code = code;
  }
}

const postProjectKitsAction = async (
  payload,
  { signal } = {},
) => {
  let response;

  try {
    response = await fetch(
      PROJECT_KITS_ENDPOINT,
      {
        method: "POST",

        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify(payload),

        signal,
      },
    );
  } catch (error) {
    if (error?.name === "AbortError") {
      throw error;
    }

    throw new ProjectKitsAPIError(
      "We couldn't connect to the ordering service. Please try again.",
    );
  }

  const responseText =
    await response.text();

  let data = {};

  if (responseText) {
    try {
      data = JSON.parse(
        responseText,
      );
    } catch (_error) {
      data = {};
    }
  }

  if (!response.ok) {
    const message =
      typeof data?.error === "string" &&
      data.error.trim()
        ? data.error.trim()
        : "The ordering service couldn't complete this request. Please try again.";

    const code =
      typeof data?.code === "string"
        ? data.code
        : "";

    throw new ProjectKitsAPIError(
      message,
      response.status,
      code,
    );
  }

  return data;
};

/*
 * ------------------------------------------------------------
 * SCHOOL LIST
 * ------------------------------------------------------------
 */

export const fetchProjectKitSchools = ({
  signal,
} = {}) =>
  postProjectKitsAction(
    {
      action: "schools",
    },
    {
      signal,
    },
  );

/*
 * ------------------------------------------------------------
 * PROJECT KIT CATALOG
 * ------------------------------------------------------------
 */

export const fetchProjectKitCatalog = ({
  schoolId,
  grade,
  signal,
}) =>
  postProjectKitsAction(
    {
      action: "catalog",

      schoolId,
      grade,
    },
    {
      signal,
    },
  );

/*
 * ------------------------------------------------------------
 * WEBSITE PROJECT KIT COUPON PREVIEW
 *
 * NO Enrollment ID.
 * NO registered-mobile verification.
 *
 * Backend checks:
 * - coupon exists
 * - coupon is active
 * - coupon validity
 * - selected school is allowed
 * - Project Kit scope
 * - minimum purchase
 * - total coupon usage
 * - current Project Kit stock
 * - discount / final price
 *
 * Preview does NOT consume coupon usage.
 * ------------------------------------------------------------
 */

export const previewProjectKitCoupon = (
  {
    offeringItemId,
    schoolId,
    grade,
    quantity,
    promoCode,
  },
  { signal } = {},
) =>
  postProjectKitsAction(
    {
      action: "preview_coupon",

      offeringItemId,

      schoolId,

      grade,

      quantity:
        Number(quantity || 1),

      promoCode:
        String(
          promoCode || "",
        )
          .trim()
          .toUpperCase(),
    },
    {
      signal,
    },
  );

/*
 * ------------------------------------------------------------
 * PLACE WEBSITE PROJECT KIT ORDER
 *
 * Student name/mobile/email are normal customer/contact fields.
 *
 * The same student name/mobile may create multiple orders.
 *
 * Coupon code is optional.
 *
 * Browser never sends a trusted price/discount/final amount.
 * Those values are recalculated securely by Supabase.
 * ------------------------------------------------------------
 */

export const placeProjectKitOrder = (
  payload,
  { signal } = {},
) =>
  postProjectKitsAction(
    {
      action: "place_order",

      ...payload,

      quantity:
        Number(
          payload?.quantity || 1,
        ),

      promoCode:
        String(
          payload?.promoCode || "",
        )
          .trim()
          .toUpperCase(),
    },
    {
      signal,
    },
  );